import { LoanForm } from './LoanForm';
import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { KREDITKARTE, type KREDITKARTE_TYPE } from '../../../types';
import { headers } from '../../constants';
import LoanCard from '../shared/LoanCard';

type Props = {
    credit: SchemaCreditRequestForm[KREDITKARTE_TYPE][number];
    index: number;
};

export const DetailedView = ({ credit, index }: Props) => (
    <td colSpan={headers.length} className="p-3">
        <LoanCard name={`${KREDITKARTE}.${index}`} credit={credit}>
            <LoanForm index={index} applicant={credit.gehoertZuAntragsteller} />
        </LoanCard>
    </td>
);
